import React from "react";
import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

const brands = [
  {
    name: "Joyalukkas",
    src: "https://customer-assets-39nsmqrw.emergentagent.net/job_ad-network-hub-3/artifacts/d4dh3pe1_images%20%282%29.png",
  },
  {
    name: "Emirates",
    src: "https://customer-assets-39nsmqrw.emergentagent.net/job_ad-network-hub-3/artifacts/2ffven7y_images%20%284%29.png",
  },
  {
    name: "Toyota",
    src: "https://customer-assets-39nsmqrw.emergentagent.net/job_ad-network-hub-3/artifacts/36g8xo1i_20190403014253_Toyota-logo.webp",
  },
  {
    name: "King's College London",
    src: "https://customer-assets-39nsmqrw.emergentagent.net/job_ad-network-hub-3/artifacts/gvoqvgbm_images%20%285%29.png",
  },
  {
    name: "BYD",
    src: "https://customer-assets-39nsmqrw.emergentagent.net/job_ad-network-hub-3/artifacts/h7n8osny_images%20%286%29.png",
  },
];

// Duplicate the list so the marquee can loop seamlessly
const loop = [...brands, ...brands, ...brands];

const BrandsMarquee = () => {
  return (
    <section
      id="brands"
      data-testid="brands-section"
      className="relative py-24 md:py-28 bg-ivory-soft border-y border-forest-800/10 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Editorial header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.9, ease }}
          className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-14 md:mb-16 items-end"
        >
          <div className="md:col-span-7">
            <span className="eyebrow flex items-center gap-3">
              <span className="w-10 h-px bg-brass" />
              Trusted By
            </span>
            <h2 className="h-display text-3xl md:text-5xl mt-6">
              Brands that choose{" "}
              <span className="italic text-brass">considered</span> attention.
            </h2>
          </div>
          <div className="md:col-span-5 md:pl-8 md:border-l md:border-forest-800/15">
            <p className="text-forest-600 text-base md:text-lg leading-relaxed font-light">
              A quiet roster of global and homegrown names who advertise where
              India's most discerning audience lingers.
            </p>
          </div>
        </motion.div>

        {/* Marquee */}
        <div className="relative brand-marquee-mask">
          <div className="flex gap-8 md:gap-10 items-stretch brand-marquee-track">
            {loop.map((b, i) => (
              <div
                key={`${b.name}-${i}`}
                data-testid={`brand-logo-${b.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="shrink-0 group relative"
                title={b.name}
              >
                {/* Editorial card frame */}
                <div className="relative hairline bg-ivory shadow-[0_18px_40px_-24px_rgba(26,40,32,0.25)] w-[220px] md:w-[280px] h-[150px] md:h-[180px] flex items-center justify-center p-4 md:p-5 transition-shadow duration-500 group-hover:shadow-[0_24px_50px_-20px_rgba(26,40,32,0.35)]">
                  {/* Corner gold marks */}
                  <span className="pointer-events-none absolute top-2 left-2 w-3 h-px bg-brass/70" />
                  <span className="pointer-events-none absolute top-2 left-2 w-px h-3 bg-brass/70" />
                  <span className="pointer-events-none absolute top-2 right-2 w-3 h-px bg-brass/70" />
                  <span className="pointer-events-none absolute top-2 right-2 w-px h-3 bg-brass/70" />
                  <span className="pointer-events-none absolute bottom-2 left-2 w-3 h-px bg-brass/70" />
                  <span className="pointer-events-none absolute bottom-2 left-2 w-px h-3 bg-brass/70" />
                  <span className="pointer-events-none absolute bottom-2 right-2 w-3 h-px bg-brass/70" />
                  <span className="pointer-events-none absolute bottom-2 right-2 w-px h-3 bg-brass/70" />

                  <img
                    src={b.src}
                    alt={b.name}
                    className="max-h-full max-w-full w-auto h-auto object-contain opacity-90 group-hover:opacity-100 transition-opacity duration-500"
                    loading="lazy"
                  />
                </div>
                {/* Caption */}
                <div className="mt-3 text-center text-[10px] tracking-[0.28em] uppercase text-forest-500 group-hover:text-brass transition-colors duration-500">
                  {b.name}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Footnote line */}
        <div className="mt-14 flex items-center gap-4 text-[10px] tracking-[0.3em] uppercase text-forest-500">
          <span className="w-10 h-px bg-brass/60" />
          <span>Selected campaigns, 2023 – 2026</span>
        </div>
      </div>
    </section>
  );
};

export default BrandsMarquee;
